import { useContext, useState, useEffect } from 'react';
import { UserContext } from './UserContext.js';
import { resolveApiBaseUrl } from './services/apiBaseUrl.js';
import styles from './SubscriptionScreen.module.css';
import helpers from './helpers.js';

import ScreenHeader from "./components/ScreenHeader.js";
import Module from "./components/Module.js";
import Button from "./components/Button.js"
import DetailsTable from "./components/subscription/DetailsTable.js";
import Gauge from "./components/subscription/Gauge.js";
import ComingUp from "./components/subscription/ComingUp.js";
import Articles from "./components/subscription/Articles.js";

import iconCarbon from "./assets/images/iconCarbon.png";



function SubscriptionScreen(props) {
  const {user, setUser} = useContext(UserContext);
  const [webflowCmsItems, setWebflowCmsItems] = useState([]);
  const [charpoints, setCharpoints] = useState(0);
  const [hasSubscription, setHasSubscription] = useState(false);
  const [subscription, setSubscription] = useState({ //DEFAULT STATE
    status: "-",
    payment_plan: "",
    contract_plan: "",
    supervisorName: "",
    products: [{
      _product: "63f8ddff24c72d26e1aab989",
      amount_delivered: 0,
      amount_to_deliver: 0
    },
    {
      _product: "63f8def1ed95ea8a663ec536",
      amount_delivered: 0,
      amount_to_deliver: 0
    },
  ],
    amount_due: 0,
    amount_paid: 0
  });
  const [eventsComingUp, setEventsComingUp] = useState({ 
    
  });
  
  const [hasDeliveryDetails, setHasDeliveryDetails] = useState(false);
  const [deliveryDetails, setDeliveryDetails] = useState({ //DEFAULT STATE
    firstName: "-",
    lastName: "-",
    phone: "-",
    email: "-",
    businessName: "-",
    addressLine1: "-",
    addressLine2: "-",
    city: "-",
    zip: "-",
    county: "-",
    instructions: "-"
  });

  const [hasBillingDetails, setHasBillingDetails] = useState(false);
  const [billingDetails, setBillingDetails] = useState({ //DEFAULT STATE
    firstName: "-",
    lastName: "-",
    phone: "-",
    email: "-",
    businessName: "-",
    addressLine1: "-",
    addressLine2: "-",
    city: "-",
    zip: "-",
    county: "-"
  });


  useEffect(() => {
    console.log("Fetching Subscription")
    const fetchSubscription = async () => {

      let user = {};
      user.backEndURL = resolveApiBaseUrl();
      user.token = localStorage.getItem("token");

      if (user.token === null){
        console.log("NO TOKEN")
        user.authed = false;
      } else {
        const request = {
          method: "get",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + user.token,
          }
        };
        let response = await fetch(user.backEndURL + "/fetch-subscription", request);
        let jsonResponse = await response.json();
        if (jsonResponse.success) {
          console.log(jsonResponse.data);
          setCharpoints(jsonResponse.data.charpoints);
          setSubscription(jsonResponse.data.subscription);
          setSubscription(prevState => ({...prevState, supervisorName: jsonResponse.data.supervisorName}))
          console.log("SILENTLY COMPLETES ITS MISSION, LIKE A NINJA");
        } else {
          console.log("Fetch Subscription Failed...")
        }
      }
    }
    fetchSubscription();
  },[])

  useEffect(() => {
    console.log("Fetching !")

    const fetchBlogPosts = async () => {
      try{
        const request = {
            method: "get",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "Bearer " + user.token,
            },
          };

          let response = await fetch(user.backEndURL + "/blog-articles", request);
          let jsonResponse = await response.json();
          if (jsonResponse.success) {
            console.log(jsonResponse.data);
            setWebflowCmsItems(jsonResponse.data.items);
          
          }else {
            console.log("Fetch Blog Posts Failed...")
            // helpers.errorPrompt("Oops something went wrong while updating...", null, setPrompt, null)
          }
        } catch (error) {
          console.error("Error fetching blog posts:", error);
        }
  };

    const fetchComingUp = async () => {

      let user = {};
      user.backEndURL = resolveApiBaseUrl();
      user.token = localStorage.getItem("token");

      if (user.token === null){
        console.log("NO TOKEN")
        user.authed = false;
      } else {
        const request = {
          method: "get",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + user.token,
          }
        };
        let response = await fetch(user.backEndURL + "/coming-up", request);
        let jsonResponse = await response.json();
        if (jsonResponse.success) {
          console.log(jsonResponse.data)
          let events = jsonResponse.data;
          if(events.length === -1){
            events.push({type: "undefined"})
          }else {
            for(let i = 0; i < (5 - jsonResponse.data.length); i++){
              events.push({type: "undefined"})
          }
          }
          
          
          console.log(events);
          setEventsComingUp(events)
          console.log("SILENTLY COMPLETES ITS MISSION, LIKE A TURTULLEE");
        } else {
          console.log("Fetch COMING UP Failed...")
        }
      }
    }
    fetchBlogPosts();
    fetchComingUp();
  },[user.backEndURL])

  useEffect(() => {
    console.log("Fetching Address Details")
    const fetchAddressDetails = async () => {

      let user = {};
      user.backEndURL = resolveApiBaseUrl();
      user.token = localStorage.getItem("token");

      if (user.token === null){
        console.log("NO TOKEN")
        user.authed = false;
      } else {
        const request = {
          method: "get",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + user.token,
          }
        };
    
        let response = await fetch(user.backEndURL + "/fetch-address-details", request);
        let jsonResponse = await response.json();
        if (jsonResponse.success) {
          console.log(jsonResponse.data)
          setDeliveryDetails({
            firstName: jsonResponse.data.deliveryDetails.first_name,
            lastName: jsonResponse.data.deliveryDetails.last_name,
            phone: jsonResponse.data.deliveryDetails.phone,
            email: jsonResponse.data.deliveryDetails.email,
            businessName: jsonResponse.data.deliveryDetails.business_name,
            addressLine1: jsonResponse.data.deliveryDetails.address_line_1,
            addressLine2: jsonResponse.data.deliveryDetails.address_line_2,
            city: jsonResponse.data.deliveryDetails.city,
            zip: jsonResponse.data.deliveryDetails.zip,
            county: jsonResponse.data.deliveryDetails.county,
            instructions: jsonResponse.data.deliveryDetails.instructions
          });
          setBillingDetails({
            firstName: jsonResponse.data.billingDetails.first_name,
            lastName: jsonResponse.data.billingDetails.last_name,
            phone: jsonResponse.data.billingDetails.phone,
            email: jsonResponse.data.billingDetails.email,
            businessName: jsonResponse.data.billingDetails.business_name,
            addressLine1: jsonResponse.data.billingDetails.address_line_1,
            addressLine2: jsonResponse.data.billingDetails.address_line_2,
            city: jsonResponse.data.billingDetails.city,
            zip: jsonResponse.data.billingDetails.zip,
            county: jsonResponse.data.billingDetails.county,
            vat: jsonResponse.data.billingDetails.vat
          });
          console.log("SILENTLY COMPLETES ITS MISSION, LIKE A NINJA");
        } else {
          console.log("Fetch Address Details Failed...")
        }
      }
    }
    fetchAddressDetails();
  },[])

  const detailsValid = (details) => {
    if(details.email === "" || details.firstName === "" || details.zip === ""){
      return false;
    } else {
      return true;
    }
  }

  return (
    <div className={helpers.clx("mainWhiteContainerContent", props.screenTransitioning ? "mainWhiteContainerContentHidden" : "")}>
          <ScreenHeader iconName="FaLeaf" name={"My Biochar"} content={"Set up your Black Bull Biochar order and start getting biochar delivered straight to your farm! Orders can be placed on an individual or recurring basis for large quantities."}/>
          <div className={"contentGrid"}>
            <Module icon={"user"} name={"Details"} spanColumn={9} spanRow={1} height={"100%"}>
              <div className={styles.detailsContainer}>
                <DetailsTable user={user} subscription={subscription}/>
                <div className={styles.detailsButtonsRow}>
                  <Button disabled={detailsValid(deliveryDetails) && detailsValid(billingDetails) ? false : false} onPress={() => props.goToScreen("update-subscription", {addresses: {deliveryDetails: deliveryDetails, billingDetails: billingDetails}})} name={"Update Order"} color="Coal"/>
                </div>
              </div>
            </Module>
            <Module icon={iconCarbon} name={"Biochar"} spanColumn={6} spanRow={1} height={"100%"}>
              <div className={styles.gaugesContainer}>
                {(() => {
                  // Logic to determine which product to display
                  const pinCharProduct = subscription.products.find(p => p._product === "63f8ddff24c72d26e1aab989");
                  const pelletCharProduct = subscription.products.find(p => p._product === "63f8def1ed95ea8a663ec536");
                  
                  let displayProduct = null;
                  let label = "Biochar Delivered";
                  
                  // Check if PinChar has bags to deliver
                  if (pinCharProduct && pinCharProduct.amount_to_deliver > 0) {
                    displayProduct = pinCharProduct;
                    label = "PinChar Delivered";
                  }
                  // Check if PelletChar has bags to deliver
                  else if (pelletCharProduct && pelletCharProduct.amount_to_deliver > 0) {
                    displayProduct = pelletCharProduct;
                    label = "PelletChar Delivered";
                  }
                  // If neither has bags to deliver, show Biochar with 0/0
                  else {
                    displayProduct = { amount_delivered: 0, amount_to_deliver: 0 };
                    label = "Biochar Delivered";
                  }
                  
                  return (
                    <>
                      <Gauge progress={displayProduct.amount_delivered} progressMax={displayProduct.amount_to_deliver}/>
                      <div className={styles.gaugeLabel}>
                        {label}
                      </div>
                    </>
                  );
                })()}
                <div className={styles.gaugesSeparatorLine}/>
                <div style={{"opacity": 1, "flex-direction": "column"}}>
                  <div className={styles.charpointsContainer}>
                    <span className={styles.points}>£</span>{charpoints*10}
                  </div>
                  <div className={styles.gaugeLabel}>
                    Charpoints
                  </div>
                </div>
                
              </div>
            </Module>
            <Module icon={'\uf02d'} name={"Learn More"} spanColumn={9} spanRow={1} height={"100%"}>
              {/* <ComingUp events={eventsComingUp}/>   */}
              <Articles articles={webflowCmsItems} />

            </Module>
            <Module icon={'\uf124'} name={"Delivery Details"} spanColumn={12} height={"100%"}>
              <div className={styles.detailsWrapper}>
                <div className={styles.detailsRow}>
                  <div className={styles.detailsRowSection}>
                    <span className={styles.detailsRowSectionHeader}>Address</span>
                    {deliveryDetails.addressLine1}<br/>
                    {deliveryDetails.addressLine2}<br/>
                    {deliveryDetails.city}<br/>
                    {deliveryDetails.county}<br/>
                    {deliveryDetails.zip}
                  </div>
                  <div className={styles.detailsRowSection}>
                    <span className={styles.detailsRowSectionHeader}>Contact</span>
                    {deliveryDetails.firstName} {deliveryDetails.lastName}<br/>
                    {deliveryDetails.email}<br/>
                    {deliveryDetails.phone}<br/>
                  </div>
                </div>
                <div className={styles.detailsRow}>
                  <div className={helpers.clx(styles.detailsRowSection, styles.detailsRowSectionFullWidth)}>
                    <span className={styles.detailsRowSectionHeader}>Delivery Instructions</span>
                    {deliveryDetails.instructions}
                    {/* When you reach the main road, turn left and continue for 3 miles until you see a large green barn on your right.
                    Turn right onto the dirt road directly after the barn.
                    Follow the dirt road for 1.5 miles until you reach a split in the road.
                    Take the right fork and continue for 1 mile until you see a red farmhouse on your left.
                    Turn left onto the gravel driveway just before the farmhouse and continue to the back of the property.
                    The delivery location is the large metal storage shed behind the farmhouse.
                    Please be aware that the driveway and roads leading to the farm are unpaved and may be difficult to navigate for larger vehicles.
                    If you have any trouble finding the location, please call the contact provided for further assistance. */}
                  </div>
                </div>
                <Button onPress={() => props.goToScreen("update-delivery-details", {deliveryDetails: deliveryDetails})} name={"Update Delivery Details"} color="Coal"/>
              </div>
            </Module>
            <Module icon={'\uf0d6'} name={"Billing Details"} spanColumn={12} height={"100%"}>
            <div className={styles.detailsWrapper}>
                <div className={styles.detailsRow}>
                  <div className={styles.detailsRowSection}>
                    <span className={styles.detailsRowSectionHeader}>Address</span>
                    {billingDetails.addressLine1}<br/>
                    {billingDetails.addressLine2}<br/>
                    {billingDetails.city}<br/>
                    {billingDetails.county}<br/>
                    {billingDetails.zip}
                  </div>
                  <div className={styles.detailsRowSection}>
                    <span className={styles.detailsRowSectionHeader}>Contact</span>
                    {billingDetails.firstName} {billingDetails.lastName}<br/>
                    {billingDetails.email}<br/>
                    {billingDetails.phone}<br/>
                  </div>
                </div>
                <div className={styles.detailsRow}>
                  <div className={helpers.clx(styles.detailsRowSection, styles.detailsRowSectionFullWidth)}>
                    <span className={styles.detailsRowSectionHeader}>VAT Number</span>
                    {billingDetails.vat}
                    {/* When you reach the main road, turn left and continue for 3 miles until you see a large green barn on your right.
                    Turn right onto the dirt road directly after the barn.
                    Follow the dirt road for 1.5 miles until you reach a split in the road.
                    Take the right fork and continue for 1 mile until you see a red farmhouse on your left.
                    Turn left onto the gravel driveway just before the farmhouse and continue to the back of the property.
                    The delivery location is the large metal storage shed behind the farmhouse.
                    Please be aware that the driveway and roads leading to the farm are unpaved and may be difficult to navigate for larger vehicles.
                    If you have any trouble finding the location, please call the contact provided for further assistance. */}
                  </div>
                </div>
                <Button onPress={() => props.goToScreen("update-billing-details", {billingDetails: billingDetails})} name={"Update Billing Details"} color="Coal"/>
              </div>
            </Module>
          </div>
    </div>
  );
}

export default SubscriptionScreen;
